import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({endPoint: `admin/Auth/Login`, method: 'POST', body, token})
}
